import {
  getToken,
  setToken,
  removeToken
} from "./token";
import tools from '@/utils/tools';
import promise from 'es6-promise'
import Axios from "axios"
import qs from 'qs'
import store from './store' //使用vuex状态管理
import router from '../router' //路由
import Raven from "raven-js";


promise.polyfill();
const server = Axios.create({
  baseURL: process.env.BASE_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'operationSystem': 'h5'
  }
});

server.defaults.headers.post.Accept = '*/*'

server.interceptors.request.use(config => {
  let token = getToken();
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  // config.headers['operationSystem'] = 'h5';
  // config.data = qs.stringify(config.data)
  return config
}, error => {

});
server.interceptors.response.use(
  res => {
    if (!res || !res.data) return {};
    if ([1091005, 1091006].indexOf(res.data.errorCode) > -1) {
      // console.log('==>', store.state.isJump)
      removeToken();
      store.commit("SET_LOG_IN_STATIC", false);
      res.data = {
        errorCode: -999,
        errorStr: "登录信息失效,请重新登录",
        results: {}
      };
      if (window.location.hash.indexOf("login") === -1) {
        window.sessionStorage.setItem(
          "jumpUrl",
          window.location.hash.replace("#", "")
        );
      }
      window.app.judgeJump();
    } else {
      if (res.data.token && res.data.token !== getToken()) {
        setToken(res.data.token);
        store.commit("SET_LOG_IN_STATIC", true);
      }
      // 非登录报错，上报sentry；
      // if (res.data.errorCode){
        // try {
        //   Raven.captureException(
        //     {
        //       Authorization: res.config.headers.Authorization,
        //       // headers: res.config.headers,
        //       url: res.config.url,
        //       method: res.config.method,
        //       reqdata: res.config.data,
        //       resdata: res.data
        //     },
        //     {
        //       level: "error",
        //       logger: "http exception"
        //     }
        //   );
        // } catch (error) {
        //   console.log(error);
        // }
      // }
       
    }
    return res.data || {};
    //设置vuex状态
  },
  error => {
    tools.showToast("网络异常！<br/>请检查系统版本或网络环境", 2100);
    // try {
    //   Raven.captureException(error, {
    //     level: "warning",
    //     logger: "httpError exception"
    //   });
    // } catch (error) {
    //   console.log(error);
    // }
    return Promise.reject({});
  }
);

export default server
